export default {
  "zh-CN": { close: "关闭图片预览", position: "第 {current} 张，共 {total} 张", imageAlt: "图片 {index}" },
  "en-US": { close: "Close image viewer", position: "Image {current} of {total}", imageAlt: "Image {index}" },
  "ar-SA": { close: "إغلاق عارض الصور", position: "الصورة {current} من {total}", imageAlt: "الصورة {index}" },
  "vi-VN": { close: "Đóng trình xem ảnh", position: "Ảnh {current} / {total}", imageAlt: "Ảnh {index}" }
}
